<template>
  <div>
    <Header></Header>
    <div class="content">
      <div class="left">
        <div class="left-cont"></div>
      </div>
      <div class="loginwrap right">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="邮箱/用户名/昵称">
              <template slot="prepend"><i class="el-icon-user"></i></template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="pass">
            <el-input
              type="password"
              v-model="ruleForm.pass"
              autocomplete="off"
            >
            <template slot="prepend"><i class="el-icon-lock"></i></template>
          </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="ex-btn"
              @click="submitForm('ruleForm')"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
        <div class="links">
          <a href="/findpassword" class="mg-r-10">忘记密码</a
          >
          <!-- <a href="/fname" class="mg-r-10">忘记会员名</a> -->
          <a href="/reg">免费注册</a>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>
<style>
body {
  background-color: #f5f5f6;
}
</style>
<style scoped>
.mg-r-10 {
  margin-right: 10px;
}
.clear {
  clear: both;
  width: 0;
  height: 0;
}
.content {
  padding: 16px 40px;
  background-color: #f5f5f6;
}
.left {
  float: left;
  max-width: 1200px;
}
.left-cont {
  max-width: 1200px;
  width: 540px;
  clear: both;
  height: 380px;
  box-sizing: border-box;
  padding: 30px 0 80px;
  background: url("../assets/login-banner.png")
    center center / contain no-repeat;
}
.right {
  float: right;
}
.loginwrap {
  width: 480px;
  margin: 0 auto;
  border: 1px solid #cccccc;
  padding: 60px 40px 30px 0px;
  margin-top: 40px;
  background-color: white;
}
.links {
  text-align: right;
}
.links a {
  font-size: 12px;
  color: #9b9ea0;
}
.ex-btn {
  width: 100%;
}
</style>
<script>
import Header from "./header";
import { mapMutations } from "vuex";

export default {
  components: {
    Header,
  },
  data() {
    var validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号或用户名或昵称不能为空"));
      } else {
        if (this.ruleForm.phone !== "") {
          //this.$refs.ruleForm.validateField("phone");
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.pass !== "") {
          //this.$refs.ruleForm.validateField("pass");
        }
        callback();
      }
    };
    return {
      ruleForm: {
        pass: "",
        phone: "",
      },
      userToken: "",
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        phone: [{ validator: validatePhone, trigger: "blur" }],
      },
    };
  },
  methods: {
    ...mapMutations(["changeLogin"]),
    submitForm(formName) {
      let _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http
            .post(
              "/api/auth2",
                {
                  phone:this.ruleForm.phone,
                  pass:this.ruleForm.pass
                }
            )
            .then((r) => {
              console.log(r);
              //登录成功
              if (r.data.code == 200) {
                _this.userToken = "Bearer " + r.data.data.token;
                // 将用户token保存到vuex中
                _this.changeLogin({ Authorization: _this.userToken });
                localStorage.setItem("name", r.data.data.username);
                localStorage.setItem("loginuid", r.data.data.userid);
                localStorage.setItem("userphoto",r.data.data.photo);
                this.$router.push({ name: "index" });
              } else {
                this.$alert("登录失败，账号或者密码不正确", "", {
                  confirmButtonText: "确定",
                });
              }
            })
            .catch((r) => {
              console.log(r);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>